import { Stack } from 'expo-router';
import { DashboardContextProvider } from 'screens/dashboard';

export default function Layout() {
  return (
    <DashboardContextProvider>
      <Stack
        screenOptions={{
          headerShown: false,
        }}
      />
    </DashboardContextProvider>
  );
}
